import "./App.css";
import Home from "./pages/home";
import "./styles/fonts.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Projetos from "./pages/Projetos/Projetos";
import SobreNos from "./pages/SobreNos/SobreNos";
import Contato from "./pages/Contato/Contato";
import Blog from "./pages/Blog/Blog";
import BlogPost from "./pages/Blog/BlogPost";
import AdminLogin from "./pages/Admin/AdminLogin";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import PostEditor from "./pages/Admin/PostEditor";
import ProtectedRoute from "./components/Admin/ProtectedRoute";
import NotFound from "./pages/NotFound/NotFound";
import ReactGA from "react-ga4";
import { useEffect } from "react";
import PageViewTracker from "./components/Analytics/PageViewTracker";
import AdminHelp from "./pages/Admin/AdminHelp";
import ProjectEditor from "./pages/Admin/ProjectEditor";
import WhatsAppButton from "./components/WhatsAppButton/WhatsAppButton";

ReactGA.initialize("G-2X7C2T9WH1");

function App() {
  useEffect(() => {
    // Send initial pageview
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  return (
    <>
      <Router>
        <PageViewTracker />
        <WhatsAppButton
          phoneNumber="5554999062213"
          message="Olá! Gostaria de saber mais sobre os serviços da Expert Vision."
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projetos" element={<Projetos />} />
          <Route path="/sobre-nos" element={<SobreNos />} />
          <Route path="/contato" element={<Contato />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:postSlug" element={<BlogPost />} />
          <Route path="/blog/:postSlug" element={<BlogPost />} />

          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/post/:action"
            element={
              <ProtectedRoute>
                <PostEditor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/post/:action/:postId"
            element={
              <ProtectedRoute>
                <PostEditor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/project/:action"
            element={
              <ProtectedRoute>
                <ProjectEditor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/project/:action/:projectId"
            element={
              <ProtectedRoute>
                <ProjectEditor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/help"
            element={
              <ProtectedRoute>
                <AdminHelp />
              </ProtectedRoute>
            }
          />

          {/* 404 Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
